var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GalleryCookie'),_c('GalleryBirthdayCake'),_c('GalleryWeddingCake'),_c('GalleryEvents')],1)}
var staticRenderFns = []

export { render, staticRenderFns }